import axios from 'axios'
import router from '../router'; 
import { Message } from 'element-ui'
import { encryptRequestBody, decryptResponseBody } from '../utils/crypto'

// HTTP AES 加密密钥 (hex 格式)
const AES_KEY = process.env.VUE_APP_AES_KEY || "";
let httpRawKey = null;

// 初始化 HTTP 加密密钥
if (AES_KEY && AES_KEY.length > 0) {
	httpRawKey = AES_KEY;
}

const http = axios.create({
	baseURL: process.env.VUE_APP_BASE_API,
	timeout: 1000 * 30
})

// 刷新token锁，避免多个请求同时触发刷新
let isRefreshing = false;
// 等待刷新的请求队列
let requestQueue = [];

// 处理刷新token后的请求重试
const retryRequests = () => {
	requestQueue.forEach(cb => cb());
	requestQueue = [];
};

/**
 * 请求拦截
 */
http.interceptors.request.use(async config => {
	let accessToken = sessionStorage.getItem("accessToken");
	if (accessToken) {
		config.headers.accessToken = encodeURIComponent(accessToken);
	}
	
	// 加密请求体（如果有数据且启用了加密）
	if (httpRawKey && config.data && Object.keys(config.data).length > 0) {
		try {
			config.data = await encryptRequestBody(config.data, 'cbc');
		} catch (e) {
			console.error('加密请求失败', e);
		}
	}
	
	return config
}, error => {
	return Promise.reject(error)
})

/**
 * 响应拦截
 */
http.interceptors.response.use(async response => {
	// 解密响应体（如果启用了加密）
	let responseData = response.data;
	if (httpRawKey && responseData) {
		try {
			responseData = await decryptResponseBody(responseData);
		} catch (e) {
			console.error('解密响应失败', e);
		}
	}
	
	if (responseData.code == 200) {
		return responseData.data;
	} else if (responseData.code == 400) {
		return exit();
	} else if (responseData.code == 401) {
		console.log("token失效，尝试重新获取")
		let refreshToken = sessionStorage.getItem("refreshToken");
		if (!refreshToken) {
			return exit()
		}
		
		// 如果正在刷新，将请求加入队列
		if (isRefreshing) {
			return new Promise((resolve) => {
				requestQueue.push(() => {
					resolve(http(response.config));
				});
			});
		}
		
		isRefreshing = true;
		
		try {
			// 发送请求, 进行刷新token操作, 获取新的token
			const refreshResponse = await axios({
				method: 'put',
				url: process.env.VUE_APP_BASE_API + '/refreshToken',
				headers: {
					refreshToken: refreshToken
				}
			});
			
			// 解密刷新token响应
			let refreshData = refreshResponse.data;
			if (httpRawKey && refreshData) {
				try {
					refreshData = await decryptResponseBody(refreshData);
				} catch (e) {
					console.error('解密刷新token响应失败', e);
				}
			}
			
			if (refreshData.code != 200) {
				isRefreshing = false;
				requestQueue = [];
				return exit();
			}
			
			// 保存token
			sessionStorage.setItem("accessToken", refreshData.data.accessToken);
			sessionStorage.setItem("refreshToken", refreshData.data.refreshToken);
			
			// 重试队列中的请求
			retryRequests();
			isRefreshing = false;
			
			// 重新发送当前请求
			return http(response.config);
		} catch (error) {
			isRefreshing = false;
			requestQueue = [];
			return exit();
		}
	} else {
		Message({
			message: responseData.message,
			type: 'error',
			duration: 1500,
			customClass: 'element-error-message-zindex'
		})
		return Promise.reject(responseData)
	}
}, error => {
	switch (error.response.status) {
		case 400:
			Message({
				message: error.response.data,
				type: 'error',
				duration: 1500,
				customClass: 'element-error-message-zindex'
			})
			break
		case 401:
			exit();
			break
		case 405:
			Message({
				message: 'http请求方式有误',
				type: 'error',
				duration: 1500,
				customClass: 'element-error-message-zindex'
			})
			break
		case 404:
		case 500:
			Message({
				message: '服务器出了点小差，请稍后再试',
				type: 'error',
				duration: 1500,
				customClass: 'element-error-message-zindex'
			})
			break
		case 501:
			Message({
				message: '服务器不支持当前请求所需要的某个功能',
				type: 'error',
				duration: 1500,
				customClass: 'element-error-message-zindex'
			})
			break
	}

	return Promise.reject(error)
})

const exit = () => {
	router.app.$eventBus.$emit("exit")
}


export default http